var locale = {
  placeholder: 'Select time'
};
export default locale;
//# sourceMappingURL=en_US.js.map



//////////////////
// WEBPACK FOOTER
// ../~/_antd@3.23.4@antd/es/time-picker/locale/en_US.js
// module id = 204
// module chunks = 0